import { useGetFeatureEnabledForCountry } from './useGetFeatureEnabledForCountry';

function useIsSelfServePremiumPlanEnabled() {
  const { isSelfServePremiumPlanEnabled } = useGetFeatureEnabledForCountry();

  return isSelfServePremiumPlanEnabled;
}

export default useIsSelfServePremiumPlanEnabled;
